import { IdentifierDTO } from '@zazume/zzm-base';
import { doGet, doPost, doPut, doDelete, doPostFileUpload, toPaginatedURL } from '../../helpers';
import { AffiliateOffer } from '#/models/rewards/AffiliateOffer';
import { PaginationOptions } from '#/hooks';

export const affiliateOffers = {
  getAll: (pagination: PaginationOptions) => () =>
    doGet<AffiliateOffer[]>(toPaginatedURL('/affiliate-offers', pagination)),
  get: (offerId: IdentifierDTO) => () => doGet(`/affiliate-offers/${offerId}`),
  create: () => (data: any): Promise<IdentifierDTO> => doPost('/affiliate-offers', data),
  update: (offerId: IdentifierDTO) => (data: any) => doPut(`/affiliate-offers/${offerId}`, data),
  delete: () => (offerId: IdentifierDTO) => doDelete(`/affiliate-offers/${offerId}`),
  reorder: () => (data: { _id: IdentifierDTO; order: number }) =>
    doPut(`/affiliate-offers/${data._id}/reorder`, { order: data.order }),
  uploadLogo: (offerId: IdentifierDTO) => (formData: FormData) =>
    doPostFileUpload(`/affiliate-offers/${offerId}/logo`, formData),
  uploadImage: (offerId: IdentifierDTO) => (formData: FormData) =>
    doPostFileUpload(`/affiliate-offers/${offerId}/image`, formData)
};
